import lodash from 'lodash';

import { nodeWithArgs, toMutation } from 'common/util/queryHelper';
import { mutateGraphQL } from 'common/util/query';
import { addApplicationMessage, } from 'common/actions/applicationMessagesActions';
import { STUDY_TEAM_CAPITAL, STUDY_USER_TYPE } from 'components/common/Study/StudyTeamMemberForm';
import { getStudyTeam } from './studySettings';
import { loadStudyDelegationsV2 } from '../../delegationOfAuthority/v2/actions/studyDelegationsV2';

export const MODIFY_STUDY_TEAM_MEMBER = 'MODIFY_STUDY_TEAM_MEMBER';

export function modifyStudyTeamMember(teamMember, delegationWithSignatures, ignoreStudyRefresh = false, refereshStudyTeam) {
    return async (dispatch, getState) => {

        const store = getState();

        const {
            study: {
                institutionId,
                binderId,
                id: studyId,
            }
        } = store;

        const { delegation, signatureExpectations, defaultSignatureExpectations } = delegationWithSignatures;

        const input = {
            institutionId,
            isClinicalStaff: false,
            hasAdminRole: teamMember.hasAdminRole,
            nameOfResearcher: teamMember.nameOfResearcher,
            studyRoleId: teamMember.studyRoleId,
            studyId,
            id: teamMember.id,
            userId: teamMember.userId,
            studyUserType: teamMember.studyUserType,
            // sub,
        };
        const delegationForMutation = !lodash.isEmpty(delegation) ? delegation : null;


        const mutation = nodeWithArgs('updateStudyTeamMemberV2', {
            institutionId,
            studyId,
            input,
            binderId,
            delegation: delegationForMutation,
            signatureExpectations: signatureExpectations,
            defaultSignatureExpectations: defaultSignatureExpectations,
        }, [
            'id'
        ]);

        const response = await mutateGraphQL(toMutation(mutation));

        if (response && response.errors) {
            return dispatch(addApplicationMessage('error', response.errors.map(e => e.message)));
        }
        if (!ignoreStudyRefresh)
            dispatch(getStudyTeam(studyId, institutionId));
        else if (refereshStudyTeam)
            refereshStudyTeam();
        dispatch(loadStudyDelegationsV2(binderId, studyId));

        let studyUserTypeDisplayName = STUDY_TEAM_CAPITAL[teamMember.studyUserType.toUpperCase()];

        if (teamMember.hasAdminRole && teamMember.studyUserType === STUDY_USER_TYPE.TEAM) {
            studyUserTypeDisplayName = 'Study User';
        }

        if (response && !response.errors) {
            if (delegationForMutation && !delegationForMutation.startDate && !ignoreStudyRefresh) {
                dispatch(addApplicationMessage('success',
                    `A PI already exists for this study, so the delegation start date for ${studyUserTypeDisplayName} was removed.`
                ));
            }

            dispatch(addApplicationMessage('success', `${studyUserTypeDisplayName} successfully updated.`));
        }
    };
}

